import { Component } from '@angular/core';
import { ApplicantsService } from '../../../services/http/applicants/applicants.service';
import { AlertService } from '../../../services/alert/alert.service';
import { LoaderService } from '../../../services/loader/loader.service';
import { Router } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { AlertType } from '../../../services/alert/alert.interface';

@Component({
  selector: 'app-recover-pass',
  standalone: true,
  imports: [FormsModule, CommonModule],
  templateUrl: './recover-pass.component.html',
  styleUrl: './recover-pass.component.scss'
})
export class RecoverPassComponent {
  usuario: string = '';
  password: string = '';
  email: string = '';
  code: string = '';
  showCode: boolean = false;

  constructor(
    private readonly applicantService: ApplicantsService,
    private readonly alertService: AlertService,
    private readonly loaderService: LoaderService,
    private readonly router: Router
  ) { }

  recoverPass() {
    this.loaderService.show();
    this.applicantService.requestCodeRegister({ identifier: this.usuario, email: this.email, password: this.password }).subscribe(
      () => {
        this.loaderService.hide();
        this.alertService.setAlert({
          message: $localize`:@@RecoverPass.SendCode:Se ha enviado un código a tu correo electrónico`,
          type: AlertType.Success,
          dismissible: true,
          dismissOnTimeout: 2000
        });
        this.showCode = true;
      }, () => {
        this.loaderService.hide();
        this.alertService.setAlert({
          message: $localize`:@@RecoverPass.ErrorSendCode:No se ha podido enviar el código a tu correo electrónico`,
          type: AlertType.Error,
          dismissible: true,
          dismissOnTimeout: 2000
        });
      }
    );
  }

  setPass() {
    this.loaderService.show();
    this.applicantService.requestCodeRegister({ identifier: this.usuario, email: this.email, password: this.password, confirmationCode: this.code }).subscribe(
      (result) => {
        this.loaderService.hide();
        this.alertService.setAlert({
          message: $localize`:@@RecoverPass.PassUpdated:Contraseña actualizada correctamente`,
          type: AlertType.Success,
          dismissible: true,
          dismissOnTimeout: 2000
        });
        this.router.navigate(['/login']);
      }
    );
  }
}
